import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import ddt from '@wix/da-ddt';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import TierPromotionCard from '../../../TierPromotionCard';
import TierPromotionCardWithFellaTooltip from '../../../TierPromotionCardWithFellaTooltip';
import { getBiDataForTierLink } from '../../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import s from './Tier.scss';
const TierMobileThumb = ({ deviation, width, height, responsive, className, style, showTierPromotionTooltip })=>{
    const { t } = useTranslation();
    const a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
    const biData = getBiDataForTierLink(deviation);
    // todo: kludge to handle width, height being in `style` too
    const { width: styleWidth, height: styleHeight } = style, nonDimStyles = _object_without_properties(style, [
        "width",
        "height"
    ]);
    const dimensions = responsive ? {
        width
    } : {
        width,
        height
    };
    // while we're here, make sure we're not somehow getting different
    // values between these two
    if (width !== styleWidth || height !== styleHeight) {
        ddt.warn('deviationviews.tiermobile', 'dimensions not matching style:', {
            deviationId: deviation.deviationId,
            showTierPromotionTooltip,
            width,
            height,
            styleWidth,
            styleHeight
        });
    }
    return /*#__PURE__*/ React.createElement("div", {
        style: _object_spread({}, nonDimStyles, dimensions),
        className: classnames(s['root'], className)
    }, showTierPromotionTooltip ? /*#__PURE__*/ React.createElement(TierPromotionCardWithFellaTooltip, _object_spread({
        deviation: deviation
    }, dimensions)) : /*#__PURE__*/ React.createElement(TierPromotionCard, _object_spread({
        deviation: deviation,
        verticalLayout: responsive
    }, dimensions)), /*#__PURE__*/ React.createElement(BiLink, {
        className: s['link-overlay'],
        biData: biData,
        "aria-label": a11yLabel,
        href: Url.userSubscriptionsPath({
            username: deviation.author.username,
            tierDeviationId: deviation.deviationId,
            tierContentType: 'deviations'
        })
    }, /*#__PURE__*/ React.createElement("span", null)));
};
TierMobileThumb.displayName = 'TierMobileThumb';
export default TierMobileThumb;

//# sourceMappingURL=Tier.js.map